import type { IModularBenefitMessages } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import GeneralInformation from '../general-information/general-information';
import { SectionContainer } from './styles';
import type { GeneralForm } from './types';

interface GeneralInformationElementProps {
  form: GeneralForm;
  errors: Record<string, boolean>;
  warnings: IModularBenefitMessages;
  successes: IModularBenefitMessages;
  benefitTypes: string[];
  isScheduledVersion: boolean;
}

const GeneralInformationElement = ({
  form,
  errors,
  warnings,
  successes,
  benefitTypes,
  isScheduledVersion,
}: GeneralInformationElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <GeneralInformation
        errors={errors}
        warnings={warnings}
        successes={successes}
        benefitTypes={benefitTypes}
        isScheduledVersion={isScheduledVersion}
      />
    </FormProvider>
  </SectionContainer>
);

export default memo(GeneralInformationElement);
